import each from "lodash/each";
import utils from "../../utils";
import { request } from "../../utils/axios-wrapper";
import utilOperations from "../../utils/operations";
import constants from "../constants";
import actions from "./actions";
import validation from "./validation";

const getDocumentTypeRequirementByState = async (stateCode) => {
    return request({
        url: constants.urls.get_docs_by_state(stateCode),
        method: "get",
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((response) => {
            return response.data;
        })
        .catch(() => {
            return "error";
        });
};

const getAllParentEntityTypes = async () => {
    return request({
        url: constants.urls.get_all_parent_entities(),
        method: "get",
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((response) => {
            return response.data;
        })
        .catch(() => {
            return "error";
        });
};

const getAllDocumentTypes = async () => {
    return request({
        url: constants.urls.get_all_document_types(),
        method: "get",
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((response) => {
            return response.data;
        })
        .catch(() => {
            return "error";
        });
};

const updateDTSRsByState = async (updatedDTSRs) => {
    return request({
        url: constants.urls.get_save_updated_dtsr(),
        method: "put",
        data: updatedDTSRs,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((response) => {
            console.log(response.data);
        })
        .catch((error) => {
            utils.actions.snackbar(true, "error", `Couldn't save changes`);
            utilOperations.reportError(error, "admin:operations:handleSaveAccountUpdates Error");
            return "error";
        });
};

const updateDocumentType = (documentTypeKey, updatedDocumentType) => {
    return (dispatch) => {
        let validationResponse = validation.validateRequestNewDocumentType(updatedDocumentType);
        if (validationResponse) {
            each(Object.keys(validationResponse), (e) => {
                console.log(e, validationResponse[e][0]);
                dispatch(actions.addError(e, validationResponse[e][0]));
            });
            return { success: false };
        } else {
            return request(
                {
                    url: constants.urls.get_save_document_type(documentTypeKey),
                    method: "put",
                    data: updatedDocumentType,
                },
                dispatch
            )
                .then(() => {
                    dispatch(utils.actions.snackbar(true, "success", "Document saved."));
                    return { success: true };
                })
                .catch((error) => {
                    dispatch(utils.actions.snackbar(true, "error", `Couldn't save changes`));
                    dispatch(utilOperations.reportError(error, "document-type:operations:updateDocumentType Error"));
                    return { success: false };
                });
        }
    };
};

const deleteDocumentType = (documentTypeId) => {
    return (dispatch) => {
        return request(
            {
                method: "delete",
                url: constants.urls.delete_document_type(documentTypeId),
            },
            dispatch
        )
            .then(() => {
                dispatch(utils.actions.snackbar(true, "success", "Document Type deleted"));
                return { success: true };
            })
            .catch((err) => {
                dispatch(utils.actions.snackbar(true, "error", `Could not delete document type. Error: ` + err));
                return { success: false };
            });
    };
};

const alterStateDocumentRequirements = (payload) => {
    return (dispatch, _) => {
        dispatch(actions.updateStateDocumentRequirements(payload));
    };
};

const handleSort = (columnName) => {
    const invertDirection = {
        asc: "desc",
        desc: "asc",
    };
    return (dispatch, getState) => {
        let sortDirection =
            getState().stateDocumentRequirementsReducer.columnToSort === columnName
                ? invertDirection[getState().stateDocumentRequirementsReducer.sortDirection]
                : "asc";
        dispatch(actions.handleSort(columnName, sortDirection));
    };
};

const getDocumentType = async (key) => {
    return request({
        url: constants.urls.get_save_document_type(key),
        method: "get",
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            return "ERROR";
        });
};

const handleInputChange = (field, value) => {
    return (dispatch) => {
        dispatch(actions.inputChange(field, value));
    };
};

const createNewDocumentType = (newDocumentType) => {
    return (dispatch) => {
        return request(
            {
                method: "post",
                url: constants.urls.create_new_document_type(),
                data: newDocumentType,
            },
            dispatch
        )
            .then((response) => {
                dispatch(utils.actions.snackbar(true, "success", "New document '" + response.data.name + "' created"));
                return { success: true };
            })
            .catch((err) => {
                dispatch(utils.actions.snackbar(true, "error", `Could not create new document type.`));
                dispatch(utilOperations.reportError(err, "document-type:operations:createNewDocumentType Error"));
                return { success: false };
            });
    };
};

const saveProxyFlags = (parentTypes) => {
    return async (dispatch) => {
        try {
            await request({
                method: "post",
                url: constants.urls.save_proxy_flags(),
                data: parentTypes,
            });
        } catch (err) {
            dispatch(utils.actions.snackbar(true, "error", "Failed to save proxy flags"));
        }
    };
};

export default {
    getDocumentTypeRequirementByState,
    getAllParentEntityTypes,
    getAllDocumentTypes,
    updateDTSRsByState,
    updateDocumentType,
    alterStateDocumentRequirements,
    getDocumentType,
    handleSort,
    deleteDocumentType,
    handleInputChange,
    createNewDocumentType,
    saveProxyFlags,
};
